import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { verificationStatusSelector } from './selectors'
import { notVerified, NOT_VERIFIED } from './slice'

export const usePhoneNumberStatus = (phoneNumber) => {
  const dispatch = useDispatch()
  const fieldStatus = useSelector(verificationStatusSelector)

  useEffect(() => {
    dispatch(notVerified())
  }, [dispatch])

  const previousPhoneNumber = useRef(phoneNumber)
  useEffect(() => {
    if (fieldStatus !== NOT_VERIFIED && previousPhoneNumber.current !== phoneNumber) {
      dispatch(notVerified())
    }

    previousPhoneNumber.current = phoneNumber
  }, [dispatch, fieldStatus, phoneNumber])
}
